import React from 'react'
import reportStyles from './PDFReportStyles';    
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'

const SummaryPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/ActionHeader2.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Parent Action Plan</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageSubTitle}>Child's physical growth optimization</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell10NB}>
                    <Image src={process.env.PUBLIC_URL + '/images/ChildHeight2.jpg'} style={reportStyles.image100Cell}/> 
                </View>
                <View style={reportStyles.cell80NB}>
                    <Text style={reportStyles.descriptionSmall}>Based on parameters: Nutrition, Physical
status, Comparative Sickness History</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell25}>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Self Control with Diet & Activity Plan</Text>
                </View>
                <View style={reportStyles.cell25}>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Child Nutrition and activity consultation</Text>
                </View>
                <View style={reportStyles.cell25}>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Optiboost Child Physical Growth and Stamina Plan</Text>
                </View>
                <View style={reportStyles.cell25BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Clinically Monitored Daily Diet</Text>
                </View>
            </View>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageText}>Child's Brain and Cognitive Development</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell80BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Self Development with Assessments
                            Follow the development activities recommended</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Consultation with Child Skills Expert
                            Recommendations for Enhanced Cognitive Skills</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>N'Hance Child IQ and Skills Package
                            Assessments, Consultations, Activities, Monitoring & More</Text>
                </View>
                <View style={reportStyles.cell20BB}>
                    <Image src={process.env.PUBLIC_URL + '/images/BoyGraduate.jpg'} style={reportStyles.image100Cell}/> 
                    <Text style={reportStyles.descriptionSmall}>Based on:
                            Development
                            milestones &
                            Cognitive Skills
                            Environment
                    </Text>
                </View>
            </View>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageText}>Other steps</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell33RB}>
                    <Text style={reportStyles.PageTextSmall}>Consultation(s)</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Doctor1.jpg'} style={reportStyles.image100Cell}/> 
                    <Text style={reportStyles.descriptionSmall}>  - Med condition
                            - Symptom score</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Paediatrician</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Child Psychologist</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Pedodontist</Text>
                </View>
                <View style={reportStyles.cell33RB}>
                    <Text style={reportStyles.PageTextSmall}>Vaccinations</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/KidVaccinate.jpg'} style={reportStyles.image100Cell}/> 
                    <Text style={reportStyles.descriptionSmall}>  -Vaccine History </Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>UIS Guidelines</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>USA Guidelines</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>IAP Guidelines</Text>
                </View>
                <View style={reportStyles.cell33RB}>
                    <Text style={reportStyles.PageTextSmall}>Investigations</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/TeddyBear.jpg'} style={reportStyles.image100Cell}/> 
                    <Text style={reportStyles.descriptionSmall}>  - Symptom Score
                            - Basic Checks</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>CBC, TSH</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Vit D3, Iron Hb Electrophoresis</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                    <Text style={reportStyles.PageTextSmall}>Serum IgA</Text>
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell10NB}>
                    <Image src={process.env.PUBLIC_URL + '/images/WhiteCheckBox.png'} style={reportStyles.image33Cell}/> 
                </View>
                <View style={reportStyles.cell90NB}>
                    <Text style={reportStyles.description}>Next Follow Up After 15 Days With Investigation Results</Text>
                </View>
            </View>
        </View>                                   
    </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>This action plan is not a medical prescription. Your doctor will provide an additional prescription, if required.
        </Text>
    </View>                            
    </Page>                       


  )          
}
  
export default SummaryPage